export const getTimeLeftLabel = (minutes: number, hours: number, days: number) => {
  const isUrgent = minutes <= 1440;

  if (days > 1) {
    return { text: `Mancano ${days} giorni`, urgent: isUrgent }
  } else if (days === 1) {
    return { text: "Manca 1 giorno", urgent: isUrgent }
  } else if (hours > 1) {
    return { text: `Mancano ${hours} ore`, urgent: isUrgent }
  } else if (hours === 1 && minutes > 55) {
    return { text: "Manca 1 ora", urgent: isUrgent }
  } else if (minutes > 1) {
    return { text: `Mancano ${minutes} minuti`, urgent: isUrgent }
  } else if (minutes === 1) {
    return { text: "Manca 1 minuto", urgent: isUrgent }
  } else {
    return { text: "Il meeting è iniziato, connettiti", urgent: true }
  }
}